var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsWhiteboardClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4H21M4 4V14C4 14.5304 4.21071 15.0391 4.58579 15.4142C4.96086 15.7893 5.46957 16 6 16H18C18.5304 16 19.0391 15.7893 19.4142 15.4142C19.7893 15.0391 20 14.5304 20 14V4M12 16V20M9 20H15",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.7L9.55002 13.15C9.45836 13.2417 9.34169 13.2875 9.20002 13.2875C9.05836 13.2875 8.94169 13.2417 8.85002 13.15C8.75836 13.0584 8.71252 12.9417 8.71252 12.8C8.71252 12.6584 8.75836 12.5417 8.85002 12.45L11.3 10L8.85002 7.55002C8.75836 7.45836 8.71252 7.34169 8.71252 7.20002C8.71252 7.05836 8.75836 6.94169 8.85002 6.85002C8.94169 6.75836 9.05836 6.71252 9.20002 6.71252C9.34169 6.71252 9.45836 6.75836 9.55002 6.85002L12 9.30002L14.45 6.85002C14.5417 6.75836 14.6584 6.71252 14.8 6.71252C14.9417 6.71252 15.0584 6.75836 15.15 6.85002C15.2417 6.94169 15.2875 7.05836 15.2875 7.20002C15.2875 7.34169 15.2417 7.45836 15.15 7.55002L12.7 10L15.15 12.45C15.2417 12.5417 15.2875 12.6584 15.2875 12.8C15.2875 12.9417 15.2417 13.0584 15.15 13.15C15.0584 13.2417 14.9417 13.2875 14.8 13.2875C14.6584 13.2875 14.5417 13.2417 14.45 13.15L12 10.7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsWhiteboardClose);
export default __webpack_public_path__ + "static/media/Icons_Whiteboard-close.2b18c833e8a44eb853ad99dd9e3cc74d.svg";
export { ForwardRef as ReactComponent };